<ion-content class="header-popover">
  <div class="header-popover-container">
    <div *ngIf="hasTitle" class="header-popover-container__title">{{ title }}</div>
    <div *ngIf="hasText" class="header-popover-container__text" [innerHTML]="text"></div>
  </div>
</ion-content>
